// FIXME: This should be exported from the ra-core package
type CanAccessParams<
  RecordType extends Record<string, any> = Record<string, any>,
> = {
  action: string;
  resource: string;
  record?: RecordType;
};

const ADMIN_ONLY_RESOURCES = [
  "sales",
  "configuration",
  "contacts",
  "contacts_summary",
  "contact_notes",
  "companies",
  "companies_summary",
  "deals",
  "deal_notes",
  "tasks",
  "tags",
  "client_contracts",
  "proposals",
];

// What a client portal user can reach (their own data is enforced by RLS).
const CLIENT_RESOURCES = [
  "portal",
  "content_pieces",
  "content_piece_versions",
  "content_comments",
  "client_reports",
  "brand_assets",
];

export const canAccess = <
  RecordType extends Record<string, any> = Record<string, any>,
>(
  role: string,
  params: CanAccessParams<RecordType>,
) => {
  if (role === "admin") {
    return true;
  }

  if (role === "client") {
    return CLIENT_RESOURCES.includes(params.resource);
  }

  // CMG360 team members work on clients only: the commercial CRM, contract
  // values, user management and settings are reserved to administrators.
  // The database enforces the same split through RLS; this only hides the UI.
  return !ADMIN_ONLY_RESOURCES.includes(params.resource);
};
